import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { TalentInsightsService } from '../_services/talent-insights.service';

@Component({
  selector: 'app-insights-joblist',
  templateUrl: './insights-joblist.component.html',
  styleUrls: ['./insights-joblist.component.scss'],
  standalone: false
})
export class InsightsJoblistComponent implements OnInit {
 isOpen = false;

  items: any[] = [];
  currentPage: number = 1;
  itemsPerPage: number = 10;
  totalItems: number = 30;
  totalPages: number = 0;
 totalEntries:any;
@Input() data:Observable<void>;
@Input() events: Observable<void>;
getDatafromInsightsTabs:any=[]
sliderJoblist:any=[]
startindex:number=0
@ViewChild('scrollContainer') scrollContainer: any;
private destroy$ = new Subject<void>();
currencyFormTab:any
jobCurrencies:any;
filterCurrency:any;
currencyData:any
constructor(private router: Router, private talentInsightsService: TalentInsightsService) {
  // this.router.events.subscribe(() => this.closeSidenav());
}

  ngOnInit() {
    this.events?.subscribe((res: any) => {
      this.getDatafromInsightsTabs = res
      Object.assign(this.getDatafromInsightsTabs, {startindex :this.startindex},{resultsize:10})
       this.talentInsightsService.getCountryCurrency().subscribe((response: any) => {
        this.currencyData = response?.data;
        this.getSampleJoblist(this.getDatafromInsightsTabs)

       })
     // this.getSampleJoblist(this.getDatafromInsightsTabs)
    })
    // create dummy 30 items
    // this.items = Array.from({ length: this.totalItems }, (_, i) => i + 1);
    // this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
    // this.totalPages = Math.ceil(this.joblist.length / this.itemsPerPage);


    this.data.subscribe((res:any)=>{
        if(res.isOpen==true){
          this.isOpen = !this.isOpen;
          this.toggleBodyScroll(this.isOpen);
        }
    })

  }
//  getCurrency(){
  //  this.talentInsightsService.getCountryCurrency().subscribe((response: any) => {
  //         this.currencyData = response?.data;
  //          this.getSampleJoblist(this.getDatafromInsightsTabs)
  //  })
//  }
  getSampleJoblist(payload){
    this.talentInsightsService.getJoblist(payload).subscribe((res:any)=>{
      this.sliderJoblist = res.data.results;

      this.sliderJoblist = this.sliderJoblist.map(job => {
        if(job?.salary_currency) {
          this.filterCurrency = this.currencyData.filter(x=>x.target_currency.toLowerCase() == job?.salary_currency.toLowerCase());
          if(this.filterCurrency?.length) {
            job.target_currency_fav_icon = this.filterCurrency[0].target_currency_fav_icon
          }
        }
        return job;
      })



      this.totalEntries = res.data.totalresultscount;
      this.totalPages = Math.ceil(this.totalEntries / 10) > 10 ? 10 :  Math.ceil(this.totalEntries / 10);
    })
  }

  getLocationsTooltip(locations: any[]): string {
    return locations?.map(l =>l.name).join('\n') || '';
  }

  get paginatedItems() {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    return this.sliderJoblist.slice(start, start + this.itemsPerPage);
  }
  setPage(index: number) {
    this.currentPage = index;
    this.startindex = (index - 1) * 10
    Object.assign(this.getDatafromInsightsTabs, {startindex :this.startindex},{resultsize:10})

    this.getSampleJoblist(this.getDatafromInsightsTabs)
      setTimeout(() => {
          this.scrollContainer.nativeElement.scrollTop = 0;
        }, 0);

  }
  nextPage() {
      this.currentPage++;
      this.startindex = this.startindex+10;
      this.getDatafromInsightsTabs.startindex = this.startindex
      this.getSampleJoblist(this.getDatafromInsightsTabs)
      setTimeout(() => {
          this.scrollContainer.nativeElement.scrollTop = 0;
        }, 0);
  }

  lastPage() {
    this.currentPage = this.totalPages;
    this.startindex = (this.currentPage - 1)*10;
      this.getDatafromInsightsTabs.startindex = this.startindex
      this.getSampleJoblist(this.getDatafromInsightsTabs);
    setTimeout(() => {
        this.scrollContainer.nativeElement.scrollTop = 0;
      }, 0);
  }

  prevPage() {
    this.currentPage--;
    this.startindex = this.startindex-10;
    this.getDatafromInsightsTabs.startindex = this.startindex
    this.getSampleJoblist(this.getDatafromInsightsTabs)

      setTimeout(() => {
      this.scrollContainer.nativeElement.scrollTop = 0;
    }, 0);
  }

  firstPage() {
    this.currentPage = 1;
    this.startindex = this.startindex%10;
    this.getDatafromInsightsTabs.startindex = this.startindex
    this.getSampleJoblist(this.getDatafromInsightsTabs)

    setTimeout(() => {
      this.scrollContainer.nativeElement.scrollTop = 0;
    }, 0);
  }



  toggleSidenav() {
    this.isOpen = !this.isOpen;
    this.toggleBodyScroll(this.isOpen);
  }

  closeSidenav() {
    this.isOpen = false;
    this.toggleBodyScroll(false);
    this.startindex = 0
    this.currentPage = 1;
    setTimeout(() => {
      this.scrollContainer.nativeElement.scrollTop = 0;
    }, 0);
  }
ngOnDestroy() {
  this.destroy$.next();
  this.destroy$.complete();
}
toggleBodyScroll(disable: boolean) {
  if (disable) {
    document.body.classList.add('no-scroll');
  } else {
    document.body.classList.remove('no-scroll');
  }
}
 formatNumberToIndianFormat(number) {
    if (number) {
      const suffixes = ['', 'K', 'M', 'B', 'T']; // Add more suffixes as needed for larger numbers
      for (const suffix of suffixes) {
        if (Math.abs(number) < 1000) {
          return Math.floor(number) + suffix;
        }
        number /= 1000;
      }
      return Math.floor(number) + 'T';
    } else {
      return 0
    }
  }
}
